module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "abas-detalhes-solicitacao"
  }, [_c('button', {
    class: [
      'abas-detalhes-solicitacao__item',
      {
        'abas-detalhes-solicitacao__item_selecionado': _vm.abaSelecionada === 'visao-geral',
      } ],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.abaSelecionada === 'visao-geral'
    },
    on: {
      "click": [function($event) {
        return _vm.$emit('update:abaSelecionada', 'visao-geral')
      }, function($event) {
        $event.preventDefault();
        return _vm.$emit('update:abaSelecionada', 'visao-geral')
      }]
    }
  }, [_vm._v("\n    Visão geral\n  ")]), _vm._v(" "), _c('button', {
    class: [
      'abas-detalhes-solicitacao__item',
      {
        'abas-detalhes-solicitacao__item_selecionado': _vm.abaSelecionada === 'linha-do-tempo',
      } ],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.abaSelecionada === 'linha-do-tempo'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('update:abaSelecionada', 'linha-do-tempo')
      }
    }
  }, [_vm._v("\n    Linha do tempo (" + _vm._s(_vm.totalDeItensNaLinhaDoTempo) + ")\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-526dac76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/AbasDetalhesSolicitacao.vue
// module id = 1114
// module chunks = 1